import {
  Slot,
  Slottable
} from "../../../chunk-5DWHOSR4.mjs";
import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-CD4FQC4X.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Badge/Badge.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var badgeVariants = cva("buyscout-badge", {
  variants: {
    variant: {
      solid: "buyscout-badge--variant-solid",
      soft: "buyscout-badge--variant-soft",
      outlined: "buyscout-badge--variant-outlined"
    },
    color: {
      primary: "buyscout-badge--color-primary",
      success: "buyscout-badge--color-success",
      warning: "buyscout-badge--color-warning",
      error: "buyscout-badge--color-error",
      neutral: "buyscout-badge--color-neutral"
    },
    size: {
      sm: "buyscout-badge--size-sm",
      md: "buyscout-badge--size-md"
    },
    count: {
      true: "buyscout-badge--count"
    }
  },
  defaultVariants: {
    variant: "soft",
    color: "neutral",
    size: "md"
  }
});
function Badge({
  ref,
  ...props
}) {
  const { variant, color, size, count = false, asChild = false, dot = false, className, children, ...rest } = props;
  const Comp = asChild ? Slot : "span";
  const classes = badgeVariants({ variant, color, size, count, className });
  return /* @__PURE__ */ jsxs(Comp, { ref, className: classes, ...rest, children: [
    dot ? /* @__PURE__ */ jsx("span", { "aria-hidden": true, className: "buyscout-badge__dot" }) : null,
    /* @__PURE__ */ jsx(Slottable, { children })
  ] });
}
Badge.displayName = "Badge";
export {
  Badge
};
//# sourceMappingURL=Badge.mjs.map